<div data-target="errorPage" cdkTrapFocus [attr.aria-modal]="true">
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>

      <section data-target="contactInfo" class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1">
          {{ 'SOMETHING_WENT_WRONG' | translate }}
        </h1>
        <p class="dt-l-article__section__description">
          {{ 'SOMETHING_WENT_WRONG_TEXT' | translate }}
        </p>
        <div class="dt-l-button-group">
          <!-- <button type="button" 
            class="dt-c-button primary orderButtonVertical"
            (click)="contactByPhone()"
          >
            {{'PHONE' | translate}}: {{contactPhone}}
          </button> -->
          <a class="dt-c-button primary orderButtonVertical" [href]="'tel:' + contactPhone">
            {{ 'PHONE' | translate }}: {{ contactPhone }}
          </a>
          <ng-container *ngIf="contactEmail">
            <div class="dt-l-button-group__separator">{{ 'OR' | translate }}</div>
            <!-- <button type="button" 
              class="dt-c-button secondary dt-email-button orderButtonVertical"
              (click)="contactByEmail()"
            >
              {{'EMAIL' | translate}}: {{contactEmail}}
            </button> -->
            <a class="dt-c-button secondary dt-email-button orderButtonVertical" [href]="'mailto:' + contactEmail">
              {{ 'EMAIL' | translate }}: {{ contactEmail }}
            </a>
          </ng-container>
        </div>
        <p *ngIf="error?.response?.statusCode"> Fehler {{ error.response.statusCode }} </p>
      </section>
      <div class="dt-l-article__section" *ngIf="errorMessage">
        <p>{{ errorMessage }}</p>
      </div>

      <div data-target="backToStartScreen" class="dt-l-article__section">
        <div class="dt-l-button-group">
          <!-- <button type="button" class="dt-c-button secondary orderButtonVertical" [routerLink]="this.utilityService.getSourceUrl4Ever() ? this.utilityService.getSourceUrl4Ever() : '/cockpit'">
            {{'BACK_TO_HOMESCREEN' | translate}}
          </button> -->
          <a class="dt-c-button secondary orderButtonVertical" [routerLink]="route">
            {{ 'BACK_TO_HOMESCREEN' | translate }}
          </a>
        </div>
      </div>
    </div>
  </article>
</div>
